export default "__VITE_ASSET__bf547443__"